import type { TrafficLightColor } from 'components/shared/TrafficLight/TrafficLight';
import { getTrafficLightColor, TrafficLight } from 'components/shared/TrafficLight/TrafficLight';
import { connect } from 'react-redux';
import { isQuoteRegulationFailed, isQuoteRegulationLoading } from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

interface StateProps {
  color: TrafficLightColor;
  className?: string;
  size?: string;
}

export type RegulatoryProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const isLoading = isQuoteRegulationLoading(state, workspaceType, tabId);
  const isFailed = isQuoteRegulationFailed(state, workspaceType, tabId);
  return {
    color: getTrafficLightColor(isLoading, isFailed),
    className: 'position-absolute start-75 translate-middle',
    size: 'xs',
  };
};
const connectTrafficLight = connect(mapStateToProps);
export const RegulationTrafficLight = connectTrafficLight(TrafficLight);
